export default __webpack_public_path__ + "static/media/IconDesc_CopperSheet.256.f3683586.png";